<template>
  <div class="app-container">
    <div class="detailHead">
      <div class="title">
        <img src="@/assets/images/accident/location.png" alt="" />
        <span
          style="
            color: #9098a3;
            font-size: 16px;
            vertical-align: top;
            margin-left: 5px;
          "
          >一键理赔 > 理赔详情</span
        >
      </div>
      <div class="btnGroup">
        <button class="back" @click="() => $router.push('/index')">
          <img src="@/assets/images/accident/back.png" />返回
        </button>
        <button class="submit" @click="save">
          确定<img src="@/assets/images/accident/submit.png" />
        </button>
        <button v-if="isHospital" @click="downloadFile" class="downloadFile">
          下载人伤直赔通知书
        </button>
      </div>
    </div>
    <div class="main editForm">
      <detailStyle :title="'伤者信息'" class="leftContent">
        <div class="accidentWrap">
          <div>
            <div class="accident-title">{{title}}</div>
            <el-input v-if="isHospital" v-model="accident.directIndemnityCode" disabled />
            <el-input v-else v-model="accident.directIndemnityCode" disabled />
          </div>
          <div>
            <div class="accident-title">关联事故编号</div>
            <el-input v-model="accident.accidentId" disabled />
          </div>
        </div>

        <div class="hurtInfo">
          <div v-if="isHospital">
            <ul class="imgbox">
              <li>
                <div class="accident-title">报警电话</div>
                <el-input v-model="accident.reportPhone" disabled />
              </li>
              <li>
                <div class="accident-title">申请时间</div>
                <el-input v-model="accident.createTime" disabled />
              </li>
              <li>
                <div class="accident-title">伤者姓名</div>
                <el-input v-model="accident.name" disabled />
              </li>
              <li>
                <div class="accident-title">伤者联系电话</div>
                <el-input v-model="accident.phone" disabled />
              </li>
              <li>
                <div class="accident-title">伤者性别</div>
                <el-input v-model="gender" disabled />
              </li>
              <li>
                <div class="accident-title">申请人身份</div>
                <el-input v-model="accident.applicantStatus" disabled />
              </li>
              <li>
                <div class="accident-title">伤者身份证号</div>
                <el-input v-model="accident.identityNum" disabled />
              </li>
              <li class="imgIcon">
                <div class="accident-title">人脸信息</div>
                <el-image
                  style="width: 100px; height: 100px"
                  :src="accident.faceInfo"
                />
              </li>
            </ul>
          </div>
          <div v-else>
            <ul>
              <li>
                <div class="accident-title">报警电话</div>
                <el-input v-model="accident.reportPhone" disabled />
              </li>
              <li>
                <div class="accident-title">申请时间</div>
                <el-input v-model="accident.accidentTime" disabled />
              </li>
              <li>
                <div class="accident-title">驾驶人姓名</div>
                <el-input v-model="accident.driverName" disabled />
              </li>
              <li>
                <div class="accident-title">驾驶人联系方式</div>
                <el-input v-model="accident.driverPhone" disabled />
              </li>
              <li>
                <div class="accident-title">车牌号码</div>
                <el-input v-model="accident.carLicenseNum" disabled />
              </li>
              <li>
                <div class="accident-title">驾驶证号码</div>
                <el-input v-model="accident.drivingLicenseNum" disabled />
              </li>
              <li>
                <div class="accident-title">伤者身份证号</div>
                <el-input v-model="accident.idCardNum" disabled />
              </li>
            </ul>
          </div>
        </div>

        <div v-if="isHospital" class="compensationInfo">
          <div>
            <div class="accident-title">申请单类型</div>
            <el-radio v-model="accident.applicationFormType" :label="0">
              急诊人伤直赔申请书
            </el-radio>
          </div>
          <button class="viewBlank">
            <a :href="accident.notification" target="_blank"
            >查看盖章通知书</a>
          </button>
        </div>
      </detailStyle>
      <div class="rightContent">
        <detailStyle :title="name+'费用材料'" class="costCard">
          <div class="costInfo">
            <div>
              <div  v-if="isHospital">
                <div class="accident-title">伤者姓名</div>
                <el-input v-model="accident.name" disabled />
              </div>
              <div v-else>
                <div  class="accident-title">车牌号码</div>
                <el-input v-model="accident.carLicenseNum" disabled />
              </div>
              
            </div>
            <div>
              <div class="accident-title">{{name}}费用总计</div>
              <el-input v-model="accident.totalCost" class="totalcost" />
              <p class="monetary_unit">元</p>
            </div>
          </div>
          <upload-cost-list
              ref="fileUpload"
              :file-type="['png', 'jpg', 'jpeg', 'pdf']"
              :auto-upload="true"
              :limit="10"
              :show-list="true"
              :custom="{ id: accident.id, cost: accident.totalCost }"
              :upload-req="uploadReq"
              :file-url="listUrl"
              @fileChange="fileChange"
            />
        </detailStyle>
        <detailStyle :title="'操作记录'" class="operationCard">
          <div class="operation">
            <operation-record ref="operationRecord" :accident-id="accident.id" />
          </div>
        </detailStyle>
      </div>
    </div>
  </div>
</template>

<script>
import OperationRecord from "../components/OperationRecord";
import uploadCostList from "../components/uploadCostList";
import { getWoundedById, getCarRescueInfoById } from "@/api/accident/edit";
import {
  uploadMaintenanceFiles,
  uploadWoundedFiles
} from "@/api/accident/upload";
import { woundedExport } from "@/api/accident/list";
import fileDownload from "js-file-download";
import detailStyle from "@/views/accident/components/detailStyle.vue";
export default {
  name: "CarForm",
  components: { OperationRecord, uploadCostList, detailStyle },
  data() {
    return {
      accident: {},
      fileList: [], // 上传文件
      title: "", // 编号名称
      name: "", // 医院/拖/修车名称
      detailReq: null, // 详情请求名称
      uploadReq: null, // 上传请求名称
      listUrl: "", // 清单文件链接
      id: "" // 详情id
    };
  },
  computed: {
    currentRole() {
      return this.$store.getters.accidentRoleName;
    },
    roles() {
      return this.$store.getters.roles;
    },
    isHospital() {
      return this.roles.includes("Hospital");
    },
    gender() {
      return this.accident.gender === 1 ? "男" : this.accident.gender === 0 ? "女" : "";
    }
  },
  created() {
    const Trailer = this.roles.includes("Trailer");
    const Repair = this.roles.includes("Repair");
    this.name = Trailer
      ? "拖车"
      : Repair
      ? "修车"
      : this.isHospital
      ? "医院"
      : "";
    this.title = this.isHospital ? "人伤直赔编号" : "车辆救援编号";
    this.detailReq = this.isHospital ? getWoundedById : getCarRescueInfoById;
    this.uploadReq = this.isHospital
      ? uploadWoundedFiles
      : uploadMaintenanceFiles;
    const detailId = this.$route.params.detailId;
    if (detailId) {
      sessionStorage.setItem("detailId", detailId);
    }
    this.id = sessionStorage.getItem("detailId");
    this.getDetails();
  },
  methods: {
    // 获取详情
    getDetails() {
      this.detailReq({ id: this.id }).then(res => {
        this.accident = res.data;
        this.listUrl = this.isHospital
          ? this.accident.treatmentListUrl
          : this.accident.maintenanceListUrl;
        this.$nextTick(() => {
          if (this.$refs.operationRecord) {
            this.$refs.operationRecord.getLog();
          }
        });
      });
    },
    // 上传文件
    fileChange(data) {
      this.fileList = data;
    },
    downloadFile() {
      woundedExport(this.accident.id).then(res => {
        fileDownload(
          res,
          `${(this.accident.accidentId &&
            this.accident.accidentId.substr(0, 8)) ||
            ""}人伤直赔通知书信息.zip`
        );
      });
    },
    // 确定，上传材料，可一次性多张，再次传覆盖
    save() {
      if (!this.accident.totalCost) {
        this.$message.error(`请输入${this.name}费用！`);
      } else if (!this.fileList.length) {
        this.$message.error("请上传费用材料！");
      } else {
        this.$refs.fileUpload.submit().then(() => {
          this.$message.success("上传成功");
          this.getDetails();
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.app-container {
  font-size: 16px;
  .detailHead {
    .submit {
      img {
        margin-left: 10px;
      }
    }
    .downloadFile {
      width: 220px;
      color: #0084ff;
    }
  }
}
.main {
  display: flex;
  margin-top: 160px;
  height: 724px;
  .el-input {
      margin-bottom: 10px;
    }
    .accidentWrap {
      margin-bottom: -10px;
    }
  .leftContent {
    width: 1000px;
    padding: 55px 65px;
  }
  .hurtInfo {
    ul {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      padding: 0;
      li {
        list-style: none;
        width: 300px;
      }
    }
    .imgbox {
      margin-bottom: 40px;
    }
  }
  .rightContent {
    width: 800px;
    height: 724px;
    margin-left: 40px;
    .costCard {
      padding: 55px 65px;
      width: 800px;
      height: 332px;
      margin-bottom: 50px;
    }
    .operation {
      width: 680px;

    }
    .operationCard {
      padding: 40px 40px 40px 55px;
      .operation-record {
        width: 680px;
        height: 255px;
        ::v-deep.operationTitle {
          width: 680px;
        }
      }
    }
  }
  .hurtInfo,
  .compensationInfo,
  .costInfo {
    margin-bottom: 20px;
  }
  .compensationInfo {
    .viewBlank {
      width: 300px;
      height: 40px;
      color: #0EBD35;
      font-size: 16px;
      background: rgba(14, 189, 53, 0.1);
      border: 1px solid #0ebd35;
      margin-top: 20px;
    }
  }
  .costInfo {
    display: flex;
    justify-content: space-between;
    .upload-demo {
      width: 300px;
    }
  }
}
.monetary_unit{
  position: absolute;
  top: 72px;
  right: 80px;
  color: #17ECFE;
}
</style>
